import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectOrderedImageVersionList } from '../../../../customer/state/image/selector'
import {isAttachmentProviderStore} from "../../../../globals/state/selector";
import {selectMedicalAssessment} from "../../../../anamnesis/state/anamnesis/selector";

export default createUIDefinition({
    taskName: taskName.CONFIRM_MEDICAL_ASSESSMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },

        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.ATTACHMENT_AGREEMENT_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            widgetProps: {
                skipImages: [
                    'lower-row-of-teeth',
                    'upper-row-with-aligner',
                    'lower-row-with-aligner',
                ],
            },
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.TRANSITION_LIST_WIDGET_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectOrderedImageVersionList,
        isAttachmentProviderStore,
        selectMedicalAssessment
    ],
    taskValidator: (
        task,
        processInstance,
        taskName,
        eventName,
        context,
        imageVersionList,
        isAttachmentProviderStore,
        medAssessment
    ) => {
        const messageList = []
        const isPretreatmentNeeded = eventName === 'pretreatment_needed'
        const canNotBeTreated = eventName === 'cannot_be_treated'
        const isDone = eventName === 'done'
        const attachmentAgreed = typeof medAssessment.formData.attachmentAgreed === "boolean";

        if (canNotBeTreated && !context.cannotBeTreatedReason) {
            messageList.push(
                createValidationMessage(
                    "Please add the reason for 'cannot be treated' before proceeding.",
                    'cannot_be_treated'
                )
            )
        }
        if (isPretreatmentNeeded && !context.preTreatmentReason) {
            messageList.push(
                createValidationMessage(
                    "Please add the reason for 'pretreatment' before proceeding.",
                    'preTreatmentReason'
                )
            )
        }
        if (!imageVersionList || Object.keys(imageVersionList).length < 8) {
            messageList.push(
                createValidationMessage(
                    'Please take all pictures first.',
                    'validateThreeShapeCase'
                )
            )
        }
        if (isDone && (context.preTreatmentReason || context.cannotBeTreatedReason)) {
            messageList.push(
                createValidationMessage(
                    'Please remove the reason for \'pretreatment\' before proceeding.',
                    'validateMedicalCheckDone'
                )
            )
        }
        if (isAttachmentProviderStore && !attachmentAgreed) {
            messageList.push(
                createValidationMessage(
                    'Please add the patient agreement for Attachment before proceeding.',
                    'attachmentAgreed',
                ),
            )
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/confirm-medical-assessment.js